import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { DataView } from "primereact/dataview";
import SearchResultItem from "../components/SearchResultItem";

import { connect } from "react-redux";
import { cancelSearch } from "../actions";
import { scrollToTop } from "../../../components/Utils";
import TablePageReport from "../../../components/TablePageReport";

const mapStateToProps = (state) => ({
  results: state.search.results,
  searchedText: state.search.searchedText,
  labelMap: state.staticPage.labelMap.search,
});
const mapDispatchToProps = (dispatch) => ({
  cancelSearch: (...args) => dispatch(cancelSearch(...args)),
});

function SearchResults({ className = "", rows = 10, results, searchedText, labelMap, cancelSearch }) {
  const [first, setFirst] = useState(0);

  useEffect(() => {
    scrollToTop();
  });

  useEffect(() => {
    return () => cancelSearch();
  }, [cancelSearch]);

  const renderItem = (item) => (
    <SearchResultItem
      data={item}
      labelMap={labelMap}
      searchedText={searchedText}
    />
  );

  if (!results) {
    return null;
  }

  if (results && results.length > 0) {
    const data = results.map((item, index) => ({ ...item, index }));
    return (
      <div className={`search-results ${className}`}>
        <div className="container">
          <DataView
            className="margin-lg-top"
            value={data}
            itemTemplate={renderItem}
            paginator={data.length > rows}
            first={first}
            onPage={(e) => setFirst(e.first)}
            rows={rows}
            paginatorLeft={
              <TablePageReport
                className="pad-lft"
                totalRecords={data.length}
                filteredRecords={data.length}
                first={first}
                rows={rows}
              />
            }
          />
        </div>
      </div>
    );
  }

  return (
    <div className={`search-results ${className}`}>
      <div className="container">
        <div className="margin-lg-top alg-center clearfix">
          <h3>Keine Suchergebnisse für</h3>
          <div className="w3-xxlarge">{`"${searchedText}"`}</div>
        </div>
      </div>
    </div>
  );
}

SearchResults.propTypes = {
  className: PropTypes.string,
  rows: PropTypes.number,
  results: PropTypes.array,
  searchedText: PropTypes.string,
  labelMap: PropTypes.shape({}).isRequired,
  cancelSearch: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(SearchResults));
